import * as React from 'react';

interface FiltersIconProps extends React.SVGProps<SVGSVGElement> {
  size: number;
  color: string;
}

export default function FiltersIcon({ size = 24, color = '#047dba' }: FiltersIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width={size} height={size}>
      <defs>
        <style>
          {`.cls-1 {
              fill: none;
          }
          
          .cls-1, .cls-2 {
            stroke-width: 0px;
          }
          
          .cls-2 {
            fill: ${color};
          }`}
        </style>
      </defs>
      <g id="icons">
        <g>
          <path
            className="cls-2"
            d="M200,69.14v20.86h20v-25c0-16.57-13.43-30-30-30h-25v20h20.86l-55.86,55.86-30-30L17.93,162.93l14.14,14.14,67.93-67.93,30,30,70-70Z"
          />
          <rect className="cls-2" x={80} y={145} width={20} height={60} />
          <rect className="cls-2" x={40} y={185} width={20} height={20} />
          <rect className="cls-2" x={120} y={155} width={20} height={50} />
          <rect className="cls-2" x={160} y={125} width={20} height={80} />
          <rect className="cls-2" x={200} y={105} width={20} height={100} />
        </g>
      </g>
    </svg>
  );
}
